<template>
  <div>
    <main>
      <!-- 首页中间模块 -->
      <homePage v-if='path ===  "homePage"'></homePage>
      <!-- 服务模块 -->
      <fuWu v-if='path ===  "fuWu"'></fuWu>
      <!-- 司法存证模块 -->
      <cunZheng v-if='path ===  "cunZheng"'></cunZheng>
      <!-- 司法数字追溯模块 -->
      <zhuiSu v-if='path ===  "zhuiSu"'></zhuiSu>
      <!-- 司法数字追溯模块 -->
      <baoHu v-if='path ===  "baoHu"'></baoHu>
      <!-- 金融类电子证据查询模块 -->
      <jrhy v-if='path ===  "jrhy"'></jrhy>
    </main>
  </div>
</template>

<script>
import '../../assets/css/index.less'
import homePage from '../../components/homePage.vue'
import fuWu from '../../components/fuWu.vue'
import cunZheng from '../../components/cunZheng.vue'
import zhuiSu from '../../components/zhuiSu.vue'
import baoHu from '../../components/baoHu.vue'
import news from '../../components/news.vue'
import newsDetail from '../../components/newsDetail.vue'
import jrhy from '../../components/jrhy.vue'

export default {
  name: 'index',
  data() {
    return {
      path: 'homePage',
      // HTP: 'http://hpf.lvjinhui.cn/',// 测试
      HTP: '49.235.92.52:8999', // 正式
    };
  },
  components: {
    homePage,
    fuWu,
    cunZheng,
    zhuiSu,
    baoHu,
    news,
    newsDetail,
    jrhy
  },
};
</script>
